import React from "react";
import { useBookingGroupNo } from "../../hooks/useBookingGroupNo";
import { useShoppingCart } from "../../pages/ShoppingCart/useShoppingCart";
import { BookingCardInfo } from "./BookingCardInfo";
import PriceRowArea from "./PriceRowArea";
import { useBookingCard } from "./useBookingCard";
import { usePriceDataHelper } from "./usePriceDataHelper";

const BookingCardBody: React.FC<{
  useBookingCardProps: ReturnType<typeof useBookingCard>;
}> = ({ useBookingCardProps }) => {
  const { priceDataHelper } = useBookingCardProps;
  const shoppingCart = useShoppingCart();
  const { bookGroupNo } = useBookingGroupNo({
    readonly: true,
  });

  // // TODO: can be optimized
  // const { bookingData } = useProductDetailPageData();
  // const prevBookingState = [isEdit ? bookingData : null].filter((x) => x);
  // const { priceDataHelper: prevPriceDataHelper } = usePriceDataHelper({
  //   bookings: bookGroupNo ? relatedBookings : [],
  // });
  const relatedBookings = (shoppingCart.cartItemsAll ?? []).filter(
    (x) => x.bookGroupNo === bookGroupNo,
  );
  const { priceDataHelper: relatedPriceDataHelper } = usePriceDataHelper({
    bookings: bookGroupNo ? relatedBookings : [],
  });

  return (
    <div
      style={{
        width: "calc(100% + 14px)",
        marginRight: "-14px",
      }}
    >
      <div className="custom-scroll-bar2 flex max-h-[45vh] flex-col overflow-y-auto pr-3">
        {!!relatedPriceDataHelper?.ls?.length && (
          <div className="opacity-40">
            <BookingCardInfo
              priceDataHelper={relatedPriceDataHelper}
              readonly={true}
            />
          </div>
        )}
        <BookingCardInfo priceDataHelper={priceDataHelper} />
        <div className="border-t border-[#DEDEDE] pt-5">
          <PriceRowArea priceDataHelper={priceDataHelper} />
        </div>
      </div>
    </div>
  );
};

export default BookingCardBody;
